import { IInputRuleBehaviorSpecifiable, IInputRuleBehavior, InputRuleKinds } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanInputRuleValidatable } from "../../../beans/objects";
import { MapTranslator } from "../../values";

export class InputRuleBehaviorTranslator {
  from(bean: IObjectBeanInputRuleValidatable): IInputRuleBehavior {
    return {
      kind: this.kind.from(bean["@data-validation"]),
    };
  }

  to(object: IInputRuleBehaviorSpecifiable) {
    return {
      dataValidation: this.kind.to(object.inputRuleBehavior.kind),
    };
  }

  private readonly kind = new MapTranslator<InputRuleKinds, string>([
    { object: InputRuleKinds.None,                            bean: "None" },
    { object: InputRuleKinds.FullWidthOnly,                   bean: "FullWidth" },
    { object: InputRuleKinds.FullWidthKanaOnly,               bean: "FullKana" },
    { object: InputRuleKinds.HalfWidthKanaOnly,               bean: "HalfKana" },
    { object: InputRuleKinds.HalfWidthNumberOnly,             bean: "HalfNumber" },
    { object: InputRuleKinds.HalfWidthAlphabetAndNumberOnly,  bean: "AlphabetNumber" },
  ], InputRuleKinds.None, "None");
}
